import { styled } from "@enfusion-ui/web-core";
export const ContentWrapper = styled.div `
  width: 100%;
  height: 100%;
  object-position: center;
  border: 1px solid var(--input-border);
`;
